// script.js

document.addEventListener('DOMContentLoaded', function () {
    // Get modal element
    const modal = document.getElementById('imageModal');
    const modalImg = document.getElementById('modalImage');
    const closeBtn = document.getElementsByClassName('close')[0];

    // Add event listeners to images
    const images = document.querySelectorAll('.modal-trigger');
    images.forEach(image => {
        image.addEventListener('click', function () {
            modal.style.display = 'flex';
            modalImg.src = this.src;
        });
    });

    // Close the modal
    closeBtn.onclick = function () {
        modal.style.display = 'none';
    }

    // Close modal if clicked outside of the image
    window.onclick = function (event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    }
});
